"use client";

import { motion, useReducedMotion } from "framer-motion";

// Short capability tags scrolled in an infinite marquee under the hero.
const TAGS = [
    "Your own private login link",
    "QR PDF invoices",
    "Automated email receipts",
    "Real P&L analytics",
    "One-click payroll",
    "Built-in POS",
    "Role-based access",
    "Full audit trail",
];

export const TrustStrip = () => {
    const reduce = useReducedMotion();

    // Duplicate the list so the loop has no visible seam.
    const loop = [...TAGS, ...TAGS];

    return (
        <section className="border-y border-border/60 py-5">
            <p className="mb-4 text-center text-xs font-medium uppercase tracking-widest text-muted-foreground">
                Everything a modern gym needs, in one place
            </p>

            {/* Edge-faded marquee track. */}
            <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
                <motion.div
                    className="flex w-max gap-3"
                    animate={reduce ? undefined : { x: ["0%", "-50%"] }}
                    transition={{ duration: 28, repeat: Infinity, ease: "linear" }}
                >
                    {loop.map((tag, i) => (
                        <span
                            key={`${tag}-${i}`}
                            className="whitespace-nowrap rounded-full border border-border/70 bg-card px-4 py-1.5 text-sm font-medium text-muted-foreground"
                        >
                            {tag}
                        </span>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};
